/*
 * @Description: 
 * @Date: 2024-12-19 16:20:41
 * @LastEditTime: 2024-12-19 16:24:27
 */
const regRules = {
	phone: [
		{
			type: 'string',
			required: true,
			message: '请输入账号或手机号！',
			trigger: ['blur'],
		},
		// {
		// 	type: 'string',
		// 	message: '请输入正确的手机号！',
		// 	trigger: ['blur'],
		// 	pattern: /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/
		// }
	],
	email: [
		{
			type: 'string',
			required: true,
			message: '请输入谷歌邮箱地址！',
			trigger: ['blur'],
		},
	],
	loginPassword: [
		{
			type: 'string',
			required: true,
			message: '请输入密码！',
			trigger: ['blur']
		},
		{ 
			min: 6, 
			max: 16, 
			message: '密码长度在6~16之间！', 
			trigger: 'blur' 
		},
	],
	agaPassword: [
		{
			type: 'string',
			required: true,
			message: '请输入密码！',
			trigger: ['blur']
		},
		{ 
			min: 6, 
			max: 16, 
			message: '密码长度在6~16之间！', 
			trigger: 'blur' 
		},
	],
	verifyCode: [
		{
			type: 'string',
			required: true,
			message: '请输入验证码！',
			trigger: ['blur']
		},
		{ 
			min: 6, 
			max: 6, 
			message: '验证码长度为6位！', 
			trigger: 'blur' 
		}
	],
	userNickName: {
		type: 'string',
		required: true,
		message: '请输入昵称！',
		trigger: ['blur']
	}
}

export default regRules